<!-- body wrapper  -->
<div class="body-wrapper">

    <!-- ==========page banner ========== -->
    <div class="page-ban">
        <div class="page-ban-inner">
            <div class="container">
                <div class="page-content" *ngIf="productType">
                    <h2 class="page-title">
                        {{productType | titlecase}} Machinery
                    </h2>
                    <div class="page-url">
                        <a routerLink="/" class="old-page">Home </a> /
                        <p>{{productType | titlecase}} Machinery</p>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <!-- ==========page banner end ====== -->

    <!-- =============News & Events========== -->
    <section>
        <div class="latest-blog cpy-8">
            <div class="container">
                <!-- row  -->
                <div class="row">
                    <div class="sec-title">
                        <div class="col-lg-7 col-md-8 col-sm-10">
                            <div class="sec-head">
                                <h4>Our Products</h4>
                                <h2 *ngIf="productType">{{productType | titlecase}} Machinery</h2>
                                <p>
                                    Cotton textile machinery automates the processing of raw cotton into fabric,
                                    including spinning, weaving, and finishing, enhancing productivity, quality, and
                                    efficiency in textile manufacturing.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <!--row end  -->
                <!-- mt-5  -->
                <div class="mt-5">
                    <!-- row  -->
                    <div class="row justify-content-start">
                        <div class="col-lg-3 col-md-4 col-sm-6 mb-4" *ngFor="let prod of productArr; let i = index;">
                            <div class="post-card product-list-main">
                                <div class="post-img news position-relative">
                                    <img [src]="prod?.image" class="product-image" alt="{{prod?.title}}">
                                    <div class="il-bg-black"></div>
                                </div>
                                <div class="post-details news">
                                    <p class="post-link text-black fw-bold">
                                        {{prod?.title}}
                                    </p>

                                    <div class="row">
                                        <div class="col-lg-6 col-md-6 col-sm-6 col-6 pe-1">
                                            <button type="button" class="btn btn-view-details"
                                                [routerLink]="['/product-details', productType, prod?.id]" data-bs-toggle="tooltip"
                                                data-bs-placement="top" title="View Details">
                                                <i class="icofont-eye-open me-1"></i>
                                                View Details
                                            </button>
                                        </div>
                                        <div class="col-lg-6 col-md-6 col-sm-6 col-6 ps-1">
                                            <a href="https://api.whatsapp.com/send?phone=918140456471&text=WELCOME TO PRISM TEXTILE MACHINERY inquiry for this products ({{prod?.title}})" target="_blank" class="btn btn-whatsapp-inquiry"
                                                data-bs-toggle="tooltip" data-bs-placement="top" title="Whatsapp Inquiry">
                                                <i class="icofont-brand-whatsapp me-1"></i>
                                                Whatsapp
                                        </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- row end  -->
                </div>
                <!-- mt-5 end  -->
            </div>
        </div>
    </section>
    <!-- =============News & Events end ========== -->

</div>